import { ApolloLink } from '@apollo/client';
export const authenticationLink = new ApolloLink((operation, forward) => {
  return forward(operation);
});
